<div class="wrapper">
    @if (seriesEpisodeWatchData()) {
    <div class="select-season-container">
        <p-select data-testid="player_series-seasons" [options]="seriesEpisodeWatchData().seriesById?.seasons"
            [ngModel]="seriesEpisodeWatchData().seasonEpisodes?.referenceId" optionLabel="title"
            optionValue="referenceId" (onChange)="onSeasonSelect($event.value)">
            <ng-template #dropdownicon>
                <i class="pi pi-chevron-down"></i>
            </ng-template>
            <ng-template let-item #item>
                {{ item.title }}{{' ('}}{{item.episodesCount}}{{' '}}{{'common.episodes' | transloco | lowercase}}{{')'}}
            </ng-template>
        </p-select>
    </div>

    <div class="episodes-container" #episodesContainer>
        @for (episode of seriesEpisodeWatchData()?.seasonEpisodes?.episodes; track episode.referenceId) {
        <player-controls-series-episode [episodeItem]="episode" data-testid="player_series-episode"
            [attr.data-reference-id]="episode.referenceId"
            [bookmarkPercentage]="getBookmarkPercentage(episode)"
            [isPlaying]="this.item().referenceId === episode.referenceId"
            [hasOutgoingEnabled]="seriesEpisodeWatchData().seriesById?.hasOutgoingEnabled"
            [hasUpcomingEnabled]="seriesEpisodeWatchData().seriesById?.hasUpcomingEnabled"
            [showAutomaticBadge]="episode.referenceId === latestAvailableEpisodeReferenceId()"
            (availabilityStartPassed)="onEpisodeAvailabilityChanged()" #episodeItem
            (onPlay)="playEpisode($event)"></player-controls-series-episode>
        }
        @if(seriesEpisodeWatchData()?.seasonEpisodes?.episodes.length === 0){
        <div class="no-episodes">{{'videostore.warning.no_videos.title' | transloco}}</div>
        }
    </div>
    }

    @if(loading()){
    <loader [miniLoader]="true"></loader>
    }
</div>